var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { PageLayout } from '../../../Components/PageLayout';
import { PendingIcon } from '../icons';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useApplication } from '../../../Contexts/ApplicationContext';
import { FeatureFlag, useFeatureFlag, } from '../../../Contexts/FeatureFlagContext';
import { PaymentFrame } from '../PaymentFrame';
import styles from './TransactionPage.module.css';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 64px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 64px;\n"])));
export function useAutoUpdateStep() {
    var _a = useApplication(), updateStepInfo = _a.stepController.updateStepInfo, order = _a.orderFacade.order;
    var _b = useState(order), prevOrder = _b[0], setPrevOrder = _b[1];
    if (prevOrder !== order && order) {
        setPrevOrder(order);
        updateStepInfo({
            nextStep: order.currentStep,
            stepsHistory: order.stepsHistory,
        });
    }
}
export var PendingTransactionPage = observer(function () {
    var _a = useApplication(), _b = _a.stepController, updateStepInfo = _b.updateStepInfo, currentStep = _b.currentStep, isCurrentStepInitial = _b.isCurrentStepInitial, order = _a.orderFacade.order;
    var _c = useState(order), prevOrder = _c[0], setPrevOrder = _c[1];
    var isDirectPayment = useFeatureFlag(FeatureFlag.DIRECT_PAYMENT);
    if (!isDirectPayment &&
        'url' in currentStep &&
        currentStep.url &&
        isCurrentStepInitial) {
        return _jsx(PaymentFrame, { url: currentStep.url });
    }
    if (prevOrder !== order && order) {
        setPrevOrder(order);
        updateStepInfo({
            nextStep: order.currentStep,
            stepsHistory: order.stepsHistory,
        });
    }
    return (_jsx(PageLayout, __assign({ hideBackArrow: true, hideHeaderChip: true }, { children: _jsxs(Wrapper, { children: [_jsx(PendingIcon, {}), _jsx("h2", __assign({ className: styles.title }, { children: "Transaction is pending" })), _jsx("p", __assign({ className: styles.text }, { children: "Please wait it will take some time, your transaction is still being processed" }))] }) })));
});
var templateObject_1;
